module.exports = __webpack_public_path__ + "static/media/phone.ec6a10cb.png";